import { FC } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';

import { DateSectionForSeries } from './DateSectionForSeries';
import { DateSectionForSingleRide } from './DateSectionForSingleRide';

interface DateSectionProps {
  isSeries: boolean;
  rideDetailsDefault: RideFormType;
  nextAvailableDate: Date;
  editMode: boolean;
}

export const DateSection: FC<DateSectionProps> = ({ isSeries, nextAvailableDate, rideDetailsDefault }) => {
  const { control } = useFormContext();

  const defaultDays = rideDetailsDefault.tripTemplateAttributes;
  const initialDaysValue = {
    monday: defaultDays?.monday || false,
    tuesday: defaultDays?.tuesday || false,
    wednesday: defaultDays?.wednesday || false,
    thursday: defaultDays?.thursday || false,
    friday: defaultDays?.friday || false,
    saturday: defaultDays?.saturday || false,
    sunday: defaultDays?.sunday || false,
  };

  const watchWaypoints: RideFormType['waypointsAttributes'] = useWatch({
    control,
    name: 'waypointsAttributes',
    defaultValue: rideDetailsDefault.waypointsAttributes,
  });

  const watchAnchorWaypoint = watchWaypoints.find((wp) => wp.anchor);

  return isSeries ? (
    <DateSectionForSeries
      initialDays={initialDaysValue}
      isLocationSelected={watchAnchorWaypoint?.location.id !== ''}
      nextAvailableDate={nextAvailableDate}
      rideDetailsDefault={rideDetailsDefault}
    />
  ) : (
    <DateSectionForSingleRide
      anchorTime={rideDetailsDefault?.anchorTime}
      isLocationSelected={watchAnchorWaypoint?.location.id !== ''}
      nextAvailableDate={nextAvailableDate}
      calendarSlug={rideDetailsDefault?.calendarSlug}
    />
  );
};
